module.exports = __webpack_public_path__ + "img/DNA_damage_aging.63d53384.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DNA_damage_aging.gif
// module id = /1fD
// module chunks = 0